/// <reference types="node" />
import { EnvWindow } from './env-window'
declare let window: EnvWindow

// the code below is copied from https://github.com/andrewmclagan/react-env
function isBrowser() {
  return Boolean(typeof window !== 'undefined' && window.__ENV)
}

export function getFiltered() {
  const prefix = process.env.REACT_ENV_PREFIX || 'REACT_APP'
  return Object.keys(process.env)
    .filter(key => new RegExp(`^${prefix}_`, 'i').test(key))
    .reduce((env: { [name: string]: string | undefined }, key) => {
      env[key] = process.env[key]
      return env
    }, {})
}

export default function env(key = ''): string | undefined {
  const prefix = (isBrowser() ? window.__ENV['REACT_ENV_PREFIX'] : process.env.REACT_ENV_PREFIX) || 'REACT_APP'
  const safeKey = `${prefix}_${key}`

  if (isBrowser()) {
    return window.__ENV[safeKey]
  }

  return process.env[safeKey]
}
